module.exports = __webpack_public_path__ + "static/media/video thumbnail.d75e2dc5.png";